import { Link as ReactRouterLink } from "react-router-dom";
import { Breadcrumb, Container, Stack } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

const breadcrumbMapping: Record<string, string> = {
  overview: "Oversikt",
  invoices: "Faktura",
  create: "Ny",
  profile: "Profil",
  customers: "Kundeliste",
  groups: "Grupper",
  templates: "Mal",
  edit: "Endre",
  privacy: "Personvernserklæring",
  auth: "Autentisering",
  login: "Innlogging",
  "magic-link": "Magisk lenke",
  signup: "Registrer",
};

export const Breadcrumbs = () => {
  const location = useLocation();
  const subPaths = location.pathname.split("/").filter(Boolean);

  if (subPaths.length === 0) {
    return null;
  }

  return (
    <Container maxW="container.lg" px={8} paddingTop={2}>
      <Stack direction="row">
        <span>{">"}</span>
        <Breadcrumb.Root>
          <Breadcrumb.List>
            {subPaths.map((subPath, i) => (
              <Breadcrumb.Item key={subPath}>
                {i < subPaths.length - 1 ? (
                  <Breadcrumb.Link asChild>
                    <ReactRouterLink
                      to={"/" + subPaths.slice(0, i + 1).join("/")}
                    >
                      {breadcrumbMapping[subPath] || subPath.split("-")[0]}
                    </ReactRouterLink>
                  </Breadcrumb.Link>
                ) : (
                  <Breadcrumb.CurrentLink>
                    {breadcrumbMapping[subPath] || subPath.split("-")[0]}
                  </Breadcrumb.CurrentLink>
                )}
                {i < subPaths.length - 1 && <Breadcrumb.Separator />}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb.List>
        </Breadcrumb.Root>
      </Stack>
    </Container>
  );
};
